import React, { useEffect, useState,useCallback,useRef } from 'react';
import { Button, Modal, Form } from 'antd';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import DynamicForm from '@/components/DynamicForm';
import improve_warning from '@/assets/images/improve_warning.webp';
import utils from 'grt-tool-lib-front';
import moment from 'moment';
import s from './style.m.less';
import ImageRender from '@/components/GrtImage/ImageRender';
utils.chineseDate(moment);
const InformationModal = (props) => {
    const labelCol = { span: 5 },
        wrapperCol = { span: 19 },
        [disabled, setDisabled] = useState(false),
        { informationVisible, improve_info, submitImproveInfo, setInformationVisible,improveInfoDetailByOrg } = props.store.login,
        { field_key, field_value,need_call_next_api,orgs } = improve_info,
        [improveInfoForm] = Form.useForm(),
        onSubmit = () => {
            improveInfoForm.submit();
        },
        onFinish = async (values) => {
            setDisabled(true);

            await submitImproveInfo(values);
            setDisabled(false);
        },
        //编辑的时候，要处理下数据，用于表单回显
        handleInitData = () => {
            let tem_field_value = field_value,
                tem_field_key = field_key;
            tem_field_key?.forEach((ele) => {
                // 日期类型
                if (ele.field_type === 5 && tem_field_value[ele.en_name]) {
                    if (ele.setting.type === 'range') {
                        let [start, end] = tem_field_value[ele.en_name];
                        tem_field_value[ele.en_name] = [moment(start), moment(end)];
                    } else {
                        tem_field_value[ele.en_name] = moment(tem_field_value[ele.en_name]);
                    }
                }
            });
            return tem_field_value;
        },
        getVerifyFormItems = () => {
            let result = [],
                formList = field_key;
            if (formList && formList.length) {
                const configList = toJS(formList);
                let requiredList = [],
                    otherList = [],
                    list;
                configList.filter((item) => {
                    if (item.required === 0) {
                        requiredList.push(item);
                    } else {
                        otherList.push(item);
                    }
                    return true;
                });
                requiredList.sort((a, b) => {
                    return parseInt(a.create_time) - b.create_time;
                });
                otherList.sort((a, b) => {
                    return parseInt(a.create_time) - b.create_time;
                });
                list = requiredList.concat(otherList);
                for (const item of list) {
                    result.push(
                        <DynamicForm
                            key={item.field_id}
                            status={'edit'}
                            {...item}
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                            form={improveInfoForm}
                            need_call_next_api={need_call_next_api}
                            orgs={orgs}
                        ></DynamicForm>
                    );
                }
            }
            return result;
        },
        onCancel = () => {
            if (props?.onCancel) {
                props.onCancel();
            } else {
                setInformationVisible(false);
            }
        },
     debounce = (func, delay)=>{
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(null, arguments);
            }, delay);
        };
    },
     prevOrgIdRef = useRef(null),
     // 获取所有 tag 类型的字段名
     getTagFieldNames = useCallback(() => {
        if (!field_key || !Array.isArray(field_key)) return [];

        return field_key
            .filter(item => item.field_type === 1 && item.setting?.type === 'tag')
            .map(item => item.en_name);
    }, [field_key]),
     onValuesChange = useCallback(
        debounce(async (changedValues, allValues) => {
          const shouldCallAPI = need_call_next_api === 1 &&
                               changedValues.org_id &&
                               allValues.org_id !== prevOrgIdRef.current;

          if (shouldCallAPI) {
            try {
              prevOrgIdRef.current = allValues.org_id;
            if(improve_info?.orgs && improve_info?.orgs?.length){
                let config_id = improve_info?.orgs.find(org => org.id === allValues.org_id)?.config_id;
                await improveInfoDetailByOrg(config_id);
            }
            } catch (error) {
              console.error('调用接口失败:', error);
            }
          }
          //tag是自己实现的组件在点击提交是有值还有错误提示需要手动处理一下
          const tagFieldNames = getTagFieldNames(),
             changedFieldName = Object.keys(changedValues)[0];

            if (tagFieldNames.includes(changedFieldName)) {
                const fieldValue = changedValues[changedFieldName];

                // 如果该字段有值，清除它的验证错误
                if (fieldValue && fieldValue.length > 0) {
                    improveInfoForm.setFields([
                        {
                            name: changedFieldName,
                            errors: []
                        }
                    ]);
                }
            }
        }, 300),
        [need_call_next_api, improveInfoDetailByOrg,getTagFieldNames]
      );
    useEffect(() => {
        if (field_value) {
            improveInfoForm.setFieldsValue(handleInitData());
        }
    }, [field_value]);
    return (
        <div>
            <Modal
                open={informationVisible}
                destroyOnClose={true}
                title={props.title || '完善身份信息'}
                footer={null}
                width={730}
                className="info_content"
                closable={props.closable === undefined ? false : props.closable}
                maskClosable={false}
                keyboard={false}
                forceRender
                onCancel={onCancel}
            >
                <div className={s['modal-wrap']}>
                    <div className={s['form-wrap']} data-scrollbar={field_key?.length > 6}>
                        <div className={s['info-wrap']}>
                            <ImageRender src={improve_warning} alt="" style={{ width: '20px', marginRight: '8px' }}></ImageRender>
                            {props.tip || '根据赛事要求，请您补充以下信息，确保无误后提交，感谢您的理解。'}
                        </div>

                        <Form
                            onValuesChange={onValuesChange}
                            form={improveInfoForm}
                            name="basic"
                            onFinish={onFinish}
                            validateTrigger="onBlur"
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                            layout="horizontal"
                            className={s['form-field']}
                        >
                            {getVerifyFormItems()}
                        </Form>
                    </div>

                    <div className={s['footer-wrap']}>
                        <Button disabled={disabled} style={{ width: '228px' }} type="primary" onClick={() => onSubmit()}>
                            提交信息
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default inject('store')(observer(InformationModal));
